
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src
import draggable from "vuedraggable";
import i18n from "@/plugins/vue-i18n";
import IComptage from "@/types/comptage.interface";
import dataService from "../../services/data.service";
import TooltipDialog from "@/components/utils/TooltipDialog.vue";

@Component({
    components: {
        HelloWorld,
        draggable,
        TooltipDialog
    }
})
export default class DataComptage extends Vue {

    drag = false;
    @Prop() readonly product: IComptage;
    @Prop() readonly dataTypes;
    sorted = [];
    oldLength;

    @Watch('product', {deep: true})
    refresh() {
        this.sorted = this.product.datas.map((x) => x).sort((a, b) => {
            return a.i - b.i;
        });
        this.oldLength = this.product.datas.length;
    }

    created() {
        this.refresh();
    }

    changeOrder(event) {
        const tmp = this.sorted.map((x) => x);
        tmp.sort((a, b) => a.i - b.i);
        const item = tmp.splice(event.moved.oldIndex, 1)[0];
        tmp.splice(event.moved.newIndex, 0, item);
        tmp.forEach(function (element, index) {
            tmp[index].i = index;
        });
        this.$emit('uploadDataToAdd', tmp);
    }

    emit(event) {
        if (this.oldLength !== event.length) {
            this.$emit('uploadDataToAdd', event);
        }
    }
}
